import * as PropTypes from 'prop-types';
import React from 'react';

const MDAndLargerDiv = props => {
    const classes = props.className ? `hidden-sm ${props.className}` : 'hidden-sm';
    return <>
        <div
            {...props}
            className={classes}
        >
            {props.children}
        </div>
    </>;
};

MDAndLargerDiv.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    style: PropTypes.object,
};
MDAndLargerDiv.defaultProps = {
    className: '',
    id: '',
    style: {},
};

export default MDAndLargerDiv;